import styled, { css } from 'styled-components';
import { media } from '../../../ui';
export const Toggle = styled.span.withConfig({
  displayName: "Style__Toggle",
  componentId: "sc-100k57j-0"
})(["position:relative;padding-left:87px;color:", ";white-space:nowrap;cursor:pointer;", ";"], ({
  theme: {
    color
  }
}) => color.primary, media.sm`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.sm}px;
  `);
export const Time = styled.div.withConfig({
  displayName: "Style__Time",
  componentId: "sc-100k57j-1"
})(["font-size:", "px;font-weight:500;line-height:1.29;", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.default, ({
  isSecondaryPoint = false
}) => isSecondaryPoint && css(["font-weight:normal;"]));
export const Date = styled.div.withConfig({
  displayName: "Style__Date",
  componentId: "sc-100k57j-2"
})(["margin-top:5px;font-size:", "px;line-height:1.17;white-space:nowrap;"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm);
export const City = styled.div.withConfig({
  displayName: "Style__City",
  componentId: "sc-100k57j-3"
})(["position:relative;margin-bottom:3px;font-size:", "px;font-weight:500;line-height:1.29;word-break:break-all;&:after{position:absolute;top:50%;left:-27.5px;width:10px;height:10px;content:'';background-color:", ";border:1px solid ", ";border-radius:50%;transform:translateY(-50%);}.icon.icon-decline{position:relative;width:1em;height:1em;margin:0 ($step * 0.5);font-size:", "px;color:white;background:", ";border-radius:50%;&:before{position:absolute;top:0;left:0;margin:0;background:transparent;}&:after{position:absolute;top:0;left:0;z-index:2;width:1em;height:1em;content:'';border:0.2em solid ", ";border-radius:50%;}}", " ", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.default, ({
  theme: {
    color
  }
}) => color.lightGray, ({
  theme: {
    color
  }
}) => color.primary, ({
  theme: {
    fontSize
  }
}) => fontSize.h6, ({
  theme: {
    color
  }
}) => color.primary, ({
  theme: {
    color
  }
}) => color.primary, ({
  isSecondaryPoint = false
}) => isSecondaryPoint && css(["font-weight:normal;&:after{left:-25.5px;width:6px;height:6px;}"]), ({
  isPrimary = false
}) => isPrimary && css(["color:", ";"], ({
  theme: {
    color
  }
}) => color.primary));
export const Address = styled.div.withConfig({
  displayName: "Style__Address",
  componentId: "sc-100k57j-4"
})(["line-height:1.29;", " ", ""], ({
  isSecondaryPoint = false
}) => isSecondaryPoint && css(["line-height:1.17;font-size:", "px;", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, media.sm`
      font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.default}px;
    `), ({
  isMuted = false
}) => isMuted && css(["color:", ";"], ({
  theme: {
    color
  }
}) => color.grayText));
export const TransferText = styled.div.withConfig({
  displayName: "Style__TransferText",
  componentId: "sc-100k57j-5"
})(["position:relative;font-size:", "px;line-height:14px;color:", ";& ~ ", "{&:after{display:none !important;}}"], ({
  theme: {
    fontSize
  }
}) => fontSize.xs, ({
  theme: {
    color
  }
}) => color.primary, City);
export const TransferCity = styled.div.withConfig({
  displayName: "Style__TransferCity",
  componentId: "sc-100k57j-6"
})(["position:absolute;top:50%;left:-29px;width:14px;height:44px;background-color:", ";border:1px solid ", ";border-radius:9px;&:before,&:after{position:absolute;left:3px;width:6px;height:6px;content:'';border:1px solid ", ";border-radius:50%;}&:before{top:4px;}&:after{bottom:4px;}"], ({
  theme: {
    color
  }
}) => color.lightGray, ({
  theme: {
    color
  }
}) => color.primary, ({
  theme: {
    color
  }
}) => color.primary);
export const Item = styled.div.withConfig({
  displayName: "Style__Item",
  componentId: "sc-100k57j-7"
})(["position:relative;display:", ";margin-bottom:16px;> div:first-child{width:50px;min-width:50px;margin-right:35px;}", " ", ";", ""], ({
  isSecondaryPoint
}) => isSecondaryPoint ? 'none' : 'flex', ({
  isExpanded
}) => isExpanded && css(["display:flex;&:last-of-type{margin-top:16px;}"]), ({
  isTransferPoint = false
}) => isTransferPoint && css(["", "{position:absolute;top:21px;}"], Time), ({
  isBigPoint = false,
  theme: {
    fontSize,
    color
  }
}) => isBigPoint && css(["", "{&:after{width:10px;height:10px;left:-27.5px;}}", "{font-size:", "px;line-height:1.17;color:", ";}"], City, Address, fontSize.sm, color.grayText));
export const WrapperPoints = styled.div.withConfig({
  displayName: "Style__WrapperPoints",
  componentId: "sc-100k57j-8"
})(["position:relative;.ReactCollapse--content .mobile-ticket__segment-item:last-child{margin-bottom:0;}", " > ", "{&:last-of-type ", "{&:before{position:absolute;top:14px;bottom:0;left:55.5px;width:14px;content:'';background-color:", ";}}}"], media.sm`
    margin-bottom: 20px;
  `, Item, Address, ({
  theme: {
    color
  }
}) => color.white);